import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
  { value: 1, label: "Legislação" },
  { value: 2, label: "Normas" },
  { value: 3, label: "Modelos" },
  { value: 4, label: "Manuais" },
];

const TipoDeDocumento = ({ field, placeholder, name, id, disabled = false }) => {
  return (
    <Select
      options={options}
      {...field}
      styles={SearchFieldStyles}
      placeholder={placeholder}
      name={name}
      isDisabled={disabled}
      id={id}
    />
  );
}

export { TipoDeDocumento, options as OpcoesTipoDeDocumento }